import { ReplacementOffer } from '@dgx-pr-spa/shared/util';
import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-floating-button',
  templateUrl: './floating-button.component.html',
  styleUrls: ['./floating-button.component.scss'],
})
export class FloatingButtonComponent {
  /**
   * Receives an array of offers to calculate the button counter
   */
  @Input() offers = [] as ReplacementOffer[];

  /**
   * Emits an object of type event back to the parent component when the compare cta is clicked
   */
  @Output() clicked: EventEmitter<void> = new EventEmitter();

  /**
   * Fires when compare cta is clicked
   */
  onClick() {
    this.clicked.emit();
  }
}
